import React, { useState } from "react";
import PropTypes from "prop-types";
import { NavLink, withRouter } from "react-router-dom";
import { NavHashLink  } from "../HashLink/HashLink";
import { Collapse, Badge } from "reactstrap";
import { Route } from "react-router";
import classnames from "classnames";

import s from "./LinksGroup.module.scss";

const LinksGroup = (props) => {

  const {
    link = "",
    childrenLinks = null,
    header = "",
    classname = "",
    isHeader = false,
    deep = 0,
    activeItem = "",
    label = "",
    exact = true
  } = props;

//   const [headerLinkClicked, setHeaderLinkClicked] = useState(false);

  const togglePanelCollapse = (link, e) => {
    props.onActiveSidebarItemChange(link);
    // setHeaderLinkClicked(true)
    // setHeaderLinkClicked(!headerLinkClicked );
    // e.preventDefault();
  }

  const isActive = props.isActive;
  const isOpen = isActive;
//   const isOpen = props.activeItem && props.activeItem.includes(props.index) && headerLinkClicked;

  // const { exact } = this.props.exact;

  if (!props.childrenLinks) {
    if (props.isHeader) {
      return (
        <li className={[s.headerLink, props.className].join(" ")}>
          <NavHashLink
            to={props.link}
            onClick={() => props.onActiveSidebarItemChange(props.link)}
            className={classnames({ [s.headerLinkActive]: isActive })}
            // activeClassName={s.headerLinkActive}
            exact={exact}
            target={props.target}
            elementId={props.elementId}
            smooth
          >
            <span className={s.icon}>
              {props.iconName}
            </span>
            {props.header}
            {props.label && <sup className={`text-${props.labelColor || 'warning'}`}>{props.label}</sup> }
            {props.badge && <Badge className={s.badge} color="secondary-red" pill>{props.badge}</Badge>}
          </NavHashLink>
        </li>
      );
    }
    return (
      <li>
        <NavHashLink
          to={props.link}
        //   activeClassName={s.headerLinkActive}
          className={classnames({ [s.headerLinkActive]: isActive })}
          onClick={(e) => {
            props.onActiveSidebarItemChange(props.link)
            if (props.link.includes('menu')) {
              e.preventDefault();
            }
          }}
          exact={exact}
          elementId={props.elementId}
          smooth
        >
          {<i className="fa fa-circle text-primary mr-2"/>} {props.header}
        </NavHashLink>
      </li>
    );
  }
  return (
    <Route
      path={props.link}
      children={(params) => {
        const { match } = params;
        return (
          <li className={classnames({ [s.headerLink]: props.isHeader }, props.className)}>
            {/* <a className={classnames("d-flex", { [s.headerLinkActive]: match }, { [s.collapsed]: isOpen }, )}
               onClick={(e) => togglePanelCollapse(props.link, e)}
               href="#top"
            >
              {props.isHeader
                ? <span className={s.icon}>
                  {props.iconName}
                </span>
                : null
              }
              {props.header} {props.label && <sup className={`text-${props.labelColor || "warning"} ml-1`}>{props}</sup>}
              <b className={["fa fa-angle-right", s.caret].join(" ")} />
            </a> */}
            <NavHashLink
                to={props.link}
                className={classnames("d-flex", { [s.headerLinkActive]: isActive }, { [s.collapsed]: isOpen }, )}
                onClick={(e) => togglePanelCollapse(props.link, e)}
                exact={exact}
                elementId={props.elementId}
                smooth
            >
              {props.isHeader
                ? <span className={s.icon}>
                  {props.iconName}
                </span>
                : null
              }
              {props.header} {props.label && <sup className={`text-${props.labelColor || "warning"} ml-1`}>{props}</sup>}
              <b className={["fa fa-angle-right", s.caret].join(" ")} />
            </NavHashLink>
            <Collapse className={s.panel} isOpen={isOpen}>
              <ul>
                {props.childrenLinks && props.childrenLinks.map((child, ind) =>
                  <LinksGroup
                    isActive={child.isActive}
                    onActiveSidebarItemChange={props.onActiveSidebarItemChange}
                    activeItem={props.activeItem}
                    header={child.header}
                    link={child.link}
                    index={child.index}
                    childrenLinks={child.childrenLinks}
                    deep={props.deep + 1}
                    elementId={child.elementId}
                    smooth
                    key={ind}
                  />,
                )}
              </ul>
            </Collapse>
          </li>
        );
      }}
    />
  );
}

LinksGroup.propTypes = {
  header: PropTypes.node.isRequired,
  link: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  childrenLinks: PropTypes.array,
  iconName: PropTypes.object,
  className: PropTypes.string,
  badge: PropTypes.string,
  label: PropTypes.string,
  activeItem: PropTypes.string,
  isHeader: PropTypes.bool,
  index: PropTypes.string,
  deep: PropTypes.number,
  onActiveSidebarItemChange: PropTypes.func,
  labelColor: PropTypes.string,
  exact: PropTypes.bool,
  elementId: PropTypes.string,
}

export default withRouter(LinksGroup);
